var cov_1hdk0kpqpf = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Gap/support.ts",
      hash = "01e1c97243d4afd4ff1e73346f16a644c8e88ee5",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Gap/support.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 15
        },
        end: {
          line: 2,
          column: 44
        }
      },
      "1": {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 3,
          column: 29
        }
      },
      "2": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 4,
          column: 37
        }
      },
      "3": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 27
        }
      },
      "4": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 49
        }
      },
      "5": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 49
        }
      },
      "6": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 33
        }
      },
      "7": {
        start: {
          line: 11,
          column: 22
        },
        end: {
          line: 11,
          column: 45
        }
      },
      "8": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 56
        }
      },
      "9": {
        start: {
          line: 12,
          column: 23
        },
        end: {
          line: 12,
          column: 56
        }
      },
      "10": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 20
        }
      }
    },
    fnMap: {
      "0": {
        name: "flexGapSupport",
        decl: {
          start: {
            line: 1,
            column: 24
          },
          end: {
            line: 1,
            column: 38
          }
        },
        loc: {
          start: {
            line: 1,
            column: 41
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 56
          }
        }, {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 56
          }
        }],
        line: 12
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export default function flexGapSupport() {
  cov_1hdk0kpqpf.f[0]++;
  var flex = (cov_1hdk0kpqpf.s[0]++, document.createElement('div'));
  cov_1hdk0kpqpf.s[1]++;
  flex.style.display = 'flex';
  cov_1hdk0kpqpf.s[2]++;
  flex.style.flexDirection = 'column';
  cov_1hdk0kpqpf.s[3]++;
  flex.style.rowGap = '1px';
  cov_1hdk0kpqpf.s[4]++;
  flex.appendChild(document.createElement('div'));
  cov_1hdk0kpqpf.s[5]++;
  flex.appendChild(document.createElement('div'));
  cov_1hdk0kpqpf.s[6]++;
  document.body.appendChild(flex);
  var isSupported = (cov_1hdk0kpqpf.s[7]++, flex.scrollHeight === 1);
  cov_1hdk0kpqpf.s[8]++;

  if (flex.parentNode) {
    cov_1hdk0kpqpf.b[0][0]++;
    cov_1hdk0kpqpf.s[9]++;
    flex.parentNode.removeChild(flex);
  } else {
    cov_1hdk0kpqpf.b[0][1]++;
  }

  cov_1hdk0kpqpf.s[10]++;
  return isSupported;
}